import React from 'react';
import WaitlistForm from './WaitlistForm';
import FeatureCard from './waitlist/FeatureCard';

const WaitlistPage: React.FC = () => {
  return (
    <div className="min-h-screen bg-gray-50">
      <div className="max-w-7xl mx-auto px-4 py-16">
        {/* Header section with title and subtitle */}
        <div className="text-center mb-16">
          <h1 className="text-4xl font-bold mb-4 text-gray-900">Join the PromptShelf Access Waitlist</h1>
          <p className="text-xl text-gray-600 max-w-3xl mx-auto">
            Be among the first to get access to our prompt curation platform.
          </p>
        </div>

        {/* Features cards */}
        <div className='bg-white rounded-lg shadow p-8 my-4 flex flex-col items-center text-center max-w-5xl mx-auto gap-14'>
          <div className='flex flex-col md:flex-row justify-around gap-8'>
            <FeatureCard
              title={'Discover'}
              subtitle={'Explore a vast library of high-quality, curated prompts for every need.'}
              SVGIcon={() => (
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" fill="currentColor" className="size-12">
                  <path fillRule="evenodd" d="M10.5 3.75a6.75 6.75 0 1 0 0 13.5 6.75 6.75 0 0 0 0-13.5ZM2.25 10.5a8.25 8.25 0 1 1 14.59 5.28l4.69 4.69a.75.75 0 1 1-1.06 1.06l-4.69-4.69A8.25 8.25 0 0 1 2.25 10.5Z" clipRule="evenodd" />
                </svg>
              )}
            />
            <FeatureCard
              title={'Create'}
              subtitle={'Craft, test, and refine your own powerful prompts with our intuitive editor.'}
              SVGIcon={() => (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="m16.862 4.487 1.687-1.688a1.875 1.875 0 1 1 2.652 2.652L6.832 19.82a4.5 4.5 0 0 1-1.897 1.13l-2.685.8.8-2.685a4.5 4.5 0 0 1 1.13-1.897L16.863 4.487Zm0 0L19.5 7.125" />
                </svg>
              )}
            />
            <FeatureCard
              title={'Manage'}
              subtitle={'Organize and version your prompts effortlessly.'}
              SVGIcon={() => (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M10.343 3.94c.09-.542.56-.94 1.11-.94h1.093c.55 0 1.02.398 1.11.94l.149.894c.07.424.384.764.78.93.398.164.855.142 1.205-.108l.737-.527a1.125 1.125 0 0 1 1.45.12l.773.774c.39.389.44 1.002.12 1.45l-.527.737c-.25.35-.272.806-.107 1.204.165.397.505.71.93.78l.893.15c.543.09.94.559.94 1.109v1.094c0 .55-.397 1.02-.94 1.11l-.894.149c-.424.07-.764.383-.929.78-.165.398-.143.854.107 1.204l.527.738c.32.447.269 1.06-.12 1.45l-.774.773a1.125 1.125 0 0 1-1.449.12l-.738-.527c-.35-.25-.806-.272-1.203-.107-.398.165-.71.505-.781.929l-.149.894c-.09.542-.56.94-1.11.94h-1.094c-.55 0-1.019-.398-1.11-.94l-.148-.894c-.071-.424-.384-.764-.781-.93-.398-.164-.854-.142-1.204.108l-.738.527c-.447.32-1.06.269-1.45-.12l-.773-.774a1.125 1.125 0 0 1-.12-1.45l.527-.737c.25-.35.272-.806.108-1.204-.165-.397-.506-.71-.93-.78l-.894-.15c-.542-.09-.94-.56-.94-1.109v-1.094c0-.55.398-1.02.94-1.11l.894-.149c.424-.07.765-.383.93-.78.165-.398.143-.854-.108-1.204l-.526-.738a1.125 1.125 0 0 1 .12-1.45l.773-.773a1.125 1.125 0 0 1 1.45-.12l.737.527c.35.25.807.272 1.204.107.397-.165.71-.505.78-.929l.15-.894Z" />
                  <path strokeLinecap="round" strokeLinejoin="round" d="M15 12a3 3 0 1 1-6 0 3 3 0 0 1 6 0Z" />
                </svg>
              )}
            />
            <FeatureCard
              title={'Share'}
              subtitle={'Share prompts with your friends and colleagues.'}
              SVGIcon={() => (
                <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth={1.5} stroke="currentColor" className="size-12">
                  <path strokeLinecap="round" strokeLinejoin="round" d="M7.217 10.907a2.25 2.25 0 1 0 0 2.186m0-2.186c.18.324.283.696.283 1.093s-.103.77-.283 1.093m0-2.186 9.566-5.314m-9.566 7.5 9.566 5.314m0 0a2.25 2.25 0 1 0 3.935 2.186 2.25 2.25 0 0 0-3.935-2.186Zm0-12.814a2.25 2.25 0 1 0 3.933-2.185 2.25 2.25 0 0 0-3.933 2.185Z" />
                </svg>
              )}
            />
          </div>
          {/* Waitlist Form */}
          <div className='gap-12'>
            <h3 className='text-xl font-bold mb-4 text-gray-900'>Be First in Line</h3>
            <p className="text-gray-600">
              Drop your email and we'll ping you the moment we launch (August 2025)
            </p>
            {/* Form section */}
            <div className="max-w-xl mx-auto overflow-hidden">
              <div className="p-10">
                <WaitlistForm />
              </div>
            </div>
          </div>
        </div>

        <div className="text-center mt-16 mb-4 text-sm text-gray-500">
          <p>© {new Date().getFullYear()} PromptShelf. All rights reserved.</p>
        </div>
      </div>
    </div>
  );
};

export default WaitlistPage;
